import { jsxs, jsx } from 'react/jsx-runtime';
import { addPropsToSVG } from '../helpers/add-props-to-svg.esm.js';

const _SocialLinkedin = (props)=>jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            jsx("path", {
                fill: "currentColor",
                d: "M20.5205 2c.8154 0 1.4795.6457 1.4795 1.442v17.1149c0 .7964-.6641 1.4431-1.4795 1.4431h-17.0453c-.8139 0-1.4752-.6467-1.4752-1.4431v-17.1148c0-.7964.6613-1.4421 1.4752-1.4421h17.0453Zm-1.4774 17.0421v-5.2344c0-2.5705-.555-4.5468-3.5586-4.5468-1.4432 0-2.4111.7914-2.8066 1.5417h-.0406v-1.3048h-2.8436v9.5443h2.9629v-4.7206c0-1.2451.2355-2.4514 1.779-2.4514 1.5224 0 1.5414 1.4238 1.5414 2.5306v4.6414h2.9661Zm-11.1103-9.5443h-2.9694v9.5443h2.9694v-9.5443Zm-1.484-4.7444c-.9527 0-1.7209.7707-1.7209 1.7201 0 .9497.7683 1.7203 1.721 1.7203.949 0 1.7193-.7706 1.7193-1.7203 0-.9494-.7704-1.7201-1.7193-1.7201Z",
                style: {
                    vectorEffect: 'non-scaling-stroke'
                }
            }),
            jsx("path", {
                stroke: "currentColor",
                strokeWidth: props.strokeWidth || 1.5,
                d: "M11.9996 7h.0007",
                style: {
                    vectorEffect: 'non-scaling-stroke'
                }
            }),
            jsx("path", {
                stroke: "currentColor",
                strokeWidth: 2,
                d: "M12 7",
                style: {
                    vectorEffect: 'non-scaling-stroke'
                }
            })
        ]
    });
const SocialLinkedin = addPropsToSVG(_SocialLinkedin);

export { SocialLinkedin };
